import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Urls from './../api/Urls';
import { VoucherDetailItem } from './../models/Order';
import Voucher, { VoucherHistory } from './../models/Voucher';

export function getVouchers(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_LIST,
        params: params,
        parser: vouchersDataListParser,
    }).get();
}

export function getVoucherDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_DETAIL,
        endpointParams: { id },
        parser: data => new Voucher({ ...data.data, id }),
    }).get();
}

export function createVoucher({ groupId, voucherNumber, currencyCode, isEnabled = true }) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_CREATE,
    }).post({ groupId, voucherNumber, currencyCode, isEnabled  });
}

export function updateVoucher({ id, isLocked, note }) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_UPDATE,
    }).put({ id, isLocked, note });
}

export function checkVoucher({ serialNumber }) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_CHECK,
    }).post({ serialNumber });
}

export function redeemVoucher({ serialNumber, checkedSystem, receiptCode, note, checkInDate, checkOutDate, operaBookingCode, propertyId, propertyOfStayId }) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_REDEEM,
    }).post({ serialNumber, checkedSystem, receiptCode, note, checkInDate, checkOutDate, operaBookingCode, propertyId, propertyOfStayId });
}

export function importVoucher(formData) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_IMPORT,
    }).post(formData);
}

export function getOrderVoucherDetailItems(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.ORDER_DETAIL_ITEM_VOUCHER,
        parser: voucherOrderItemsDataParser,
        params: params,
    }).get();
}

export function exportExcel(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_EXPORT_EXCEL,
        isDownload: true,
        params: params,
    }).get();
}

export function getVoucherHistory(id, params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_DETAIL_HISTORY,
        params: params,
        endpointParams: { id },
        parser: voucherHistoryListParser,
    }).get();
}

const voucherOrderItemsDataParser = (data) => ({
    vouchers: (data.data.result || []).map(item => new VoucherDetailItem(item)),
    filters: {
        pageIndex: data.data.pageIndex,
        pageSize: data.data.pageSize,
        totalCount: data.data.totalCount,
    }
});

function vouchersDataListParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new Voucher(item))
    }
}

function voucherHistoryListParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new VoucherHistory(item))
    }
}